export const AuthorizationUtils = {
  base64: function (merchantId, apiKey) {
    return 'Basic ' + btoa(merchantId + ':' + apiKey);
  }
};


// WEBPACK FOOTER //
// ./src/utils/AuthorizationUtils.js